module.exports = __webpack_public_path__ + "static/media/8.0b492f57.JPG";